"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isScrollPositionStart = exports.isScrollPositionEnd = exports.hasScrollBehavior = exports.centerOn = void 0;
const centerOn = function (e, scrollRef) {
  var _y$offsetWidth;
  const x = e;
  const y = scrollRef.current;
  const scrollLeft = x.offsetLeft + x.offsetWidth / 2 - ((_y$offsetWidth = y === null || y === void 0 ? void 0 : y.offsetWidth) !== null && _y$offsetWidth !== void 0 ? _y$offsetWidth : 0) / 2;
  if (scrollRef.current) {
    scrollRef.current.scrollLeft = scrollLeft;
  }
  return scrollLeft;
};
exports.centerOn = centerOn;
const isScrollPositionStart = function (scrollContainer) {
  return scrollContainer.scrollLeft <= 0;
};
exports.isScrollPositionStart = isScrollPositionStart;
const isScrollPositionEnd = function (scrollContainer) {
  const endPosition = scrollContainer.scrollWidth - scrollContainer.offsetWidth;
  return Math.ceil(scrollContainer.scrollLeft) >= endPosition;
};
exports.isScrollPositionEnd = isScrollPositionEnd;
const hasScrollBehavior = function (scrollContainer) {
  return Math.floor(scrollContainer.scrollWidth) !== Math.floor(scrollContainer.offsetWidth);
};
exports.hasScrollBehavior = hasScrollBehavior;